import { Box, Typography } from "@mui/material";
import { useState } from "react";

interface Tab {
    label: string;
    value: string;
}

interface CustomTabsProps {
    tabs: Tab[];
    value?: string;
    defaultValue?: string;
    onChange?: (value: string) => void;
}

export default function CustomTabs({
    tabs,
    value,
    defaultValue,
    onChange,
}: CustomTabsProps) {
    const [internalValue, setInternalValue] = useState(defaultValue || tabs[0]?.value);
    const activeTab = value !== undefined ? value : internalValue;

    const handleTabClick = (newValue: string) => {
        if (value === undefined) {
            setInternalValue(newValue);
        }
        onChange?.(newValue);
    };

    return (
        <Box
            sx={{
                display: "flex",
                borderBottom: "2px solid #e0e0e0",
                gap: { xs: "24px", md: "48px" },
                width: "100%",
                justifyContent: { xs: "flex-start", md: "space-between" },
                px: { xs: 2, md: 20 },
                overflowX: { xs: "auto", md: "visible" },
                '&::-webkit-scrollbar': { display: 'none' }, // Check if user wants scrollbar hidden
                scrollbarWidth: 'none',
            }}
        >
            {tabs.map((tab) => {
                const isActive = tab.value === activeTab;

                return (
                    <Box
                        key={tab.value}
                        onClick={() => handleTabClick(tab.value)}
                        sx={{
                            position: "relative",
                            cursor: "pointer",
                            paddingBottom: "12px",
                            flexShrink: 0,
                            transition: "all 0.3s ease",
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: { xs: "14px", md: "18px" },
                                fontWeight: isActive ? 600 : 400,
                                color: isActive ? "#333333" : "#999999",
                                transition: "all 0.3s ease",
                                "&:hover": {
                                    color: isActive ? "#333333" : "#666666",
                                },
                            }}
                        >
                            {tab.label}
                        </Typography>

                        {/* Active indicator */}
                        {isActive && (
                            <Box
                                sx={{
                                    position: "absolute",
                                    bottom: "-2px",
                                    left: 0,
                                    right: 0,
                                    height: "5px",
                                    backgroundColor: "#ff6b35",
                                    borderRadius: "2px 2px 0 0",
                                }}
                            />
                        )}
                    </Box>
                );
            })}
        </Box>
    );
}
